import { useSelector } from 'react-redux';

import { enableAnalyticsByUser } from '../constants/featureFlag';
import { getIsAnalyticsEnabled } from '../utils/analytics';
import { useFeatureFlag } from './useFeatureFlag';

export function useAnalyticsPermission() {
  const currentUser = useSelector((state) => state.role.user);
  const currentSupplier = useSelector((state) => state.role.supplier);
  const allowedAnalyticsEmails = useFeatureFlag(enableAnalyticsByUser, JSON.stringify([]));

  const { enabled_for_visibility } = getAnalyticsSettingsFromSupplier(currentSupplier);

  const isAnalyticsEnabled = getIsAnalyticsEnabled({
    featureFlagEmailBasedValue: allowedAnalyticsEmails,
    userEmail: currentUser?.email,
    isEnabledFromSupplierSettings: !!enabled_for_visibility,
  });

  return { isAnalyticsEnabled };
}

const getAnalyticsSettingsFromSupplier = (supplier) => supplier?.settings?.analytics || {};
